import { mergeQueryString } from 'bernie-core';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UitkNotificationBadge1 } from 'uitk-react-badge';
import { UitkButtonSize } from 'uitk-react-button';
import { UitkIcon } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';
import { SecondaryButtonTracked } from '../../../utils/click-trackers';
import { useStores } from '../../../utils/hooks';

export interface SortFilterDialogButtonProps {
  pageId?: string;
}

export const SortFilterDialogButton: React.FC<SortFilterDialogButtonProps> = () => {
  const { activitySearchStore } = useStores();
  const history = useHistory();
  const location = useLocation();
  const href = `${location.pathname}?${mergeQueryString(location.search, { pwaDialog: 'filter' })}`;
  const revealAction = activitySearchStore.universalSortAndFilter?.revealAction;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    event.preventDefault();
    const query = mergeQueryString(history.location.search, { pwaDialog: 'filter' });
    history.push({
      pathname: location.pathname,
      search: query,
      state: {},
    });
  };

  return (
    <UitkSpacing margin={{ blockend: 'six' }}>
      <SecondaryButtonTracked
        data-testid="sort-filter-dialog-button"
        rfrr={revealAction?.action.analytics.referrerId}
        linkName={revealAction?.action.analytics.linkName}
        id="sort-and-filter-button"
        aria-label={revealAction?.accessibility}
        type="button"
        role="button"
        isFullWidth={true}
        size={UitkButtonSize.MEDIUM}
        onClick={handleClick}
        href={href}
      >
        {revealAction?.badge ? <UitkNotificationBadge1 text={revealAction.badge} /> : <UitkIcon name="tune" />}
        {revealAction?.primary}
      </SecondaryButtonTracked>
    </UitkSpacing>
  );
};
